import { pagination } from './utilities/pagination.js';
const article = require('tpl/society/article.html');
const fans = require('tpl/society/fans.html');
const branch = require('tpl/society/branch.html');
const organizationMember = require('tpl/society/organization.html');
const $ajax = window.util.ajax;
const dynamic = require("tpl/dynamic/dynamic.html");
const __data = {
    // 每页显示的动态数量
    PAGE_LIMIT: 20,
    // 是否正在加载数据中的状态
    isLoadMore: false,
    // 是否有下一页数据
    hasNextPage: true,
    page: 2,
    BRANCH_PAGE: 1,
    postUrl: null
};
const pageType = window.util.queryString('pageType') || $('._currentPageType').val();


const __org = {

    getOrgBranch(type) {
        let title = $('._orgBranch').data('title');
        let crowdId = $('._orgBranch').data('id');

        __org.submitDataHandle('/Org/getbranchlist', 'get', { crowd: title, page: __data.BRANCH_PAGE }, ({ data }) => {

            if (type == 'page') {
                $('._branchBody').html(__org.createBranch(data.list));
                __org.initPagination(data.total, () => {
                    __org.getOrgBranch('page');
                });
            } else {
                layer.open({
                    type: 1,
                    title: '分支机构',
                    area: ['760px', '500px'],
                    offset: 'auto',
                    btn: false,
                    closeBtn: 2,
                    shadeClose: false,
                    skin: 'common-modal',
                    content: branch({ title }),
                    success: () => {
                        $('._branchBody').html(__org.createBranch(data.list));
                        __org.initPagination(data.total, () => {
                            __org.getOrgBranch('page');
                        });
                    }
                });
            }
        });
    },
    createBranch(data) {
        let html = '';

        data.forEach((item, index) => {
            let num = index + 1 + (__data.BRANCH_PAGE - 1) * 10;

            html +=`<tr>
                        <td><span>${num}</span></td>
                        <td>${item.name}</td>
                        <td>${item.sub_type}</td>
                        <td>${item.founding_time}</td>
                    </tr>`;

        });

        return html;
    },
    // 初始化分页
    initPagination(total, callback, pageId) {
        var pagId = pageId || "_unitPage";
        var $pagCon = $("#" + pagId).parent();
        var currPage = __data.BRANCH_PAGE || 1;

        // 初始化分页的时候根据当前的数据条数判断是否需要显示分页

        if (total) {
            $pagCon.show();

            __org.createPag(pagId, total, currPage, function (page) {
                __data.BRANCH_PAGE = page;
                callback && callback();
            });
        } else {
            $pagCon.hide();
        }
    },
    // 创建分页方法
    createPag(container, total, curr, cb, opts) {
        var opts = opts || {},
            pageLimit = opts.pageLimit || 10,
            totalPage = opts.totalPage || (total / pageLimit),
            _curr = curr || 1;

        $('#' + container).pagination({
            totalData: total,
            showData: pageLimit,
            current: _curr,
            pageContent: totalPage,
            jump: true,
            showTotalPage: true,
            coping: true,
            jumpBtn: '跳转',
            callback: function (api) {
                var _currentPage = api.getCurrent();

                if (typeof cb === 'function') {
                    cb(_currentPage);
                }
            }
        });
    },
    tabChange() {
        var index = $(this).index();

        $(this).addClass('active').siblings('li').removeClass('active');
        $('.tab-change-box').eq(index).show().siblings('.tab-change-box').hide();
    },
    slide() {
        $(this).parents('li').addClass('active').siblings('li').removeClass('active');
        $(this).parents('p').siblings('ul').slideToggle();
        $(this).toggleClass('icon-zhankai icon-hebing');
    },
    showDownList() {
        var flag = $(this).attr('data-flag');

        $(this).siblings('.learning-show-box').slideToggle();
        if (flag == 'true') {
            $(this).html('-');
            $(this).attr('data-flag', 'false');
            $(this).parents('li').addClass('active').css('border-bottom', '0');
        } else {
            $(this).html('+');
            $(this).attr('data-flag', 'true');
            $(this).parents('li').removeClass('active').css('border-bottom', '2px solid #E5E5E5');
        }
    },
    // 加关注操作
    followingHandle(e) {
      debugger
        e.preventDefault();
        let $this = $(this);
        let id = $this.data("id");

        __org.submitDataHandle('/org/ajaxAddFollow', 'post', { crowd_id: id }, (data) => {
            layer.msg("添加关注成功");
    
            $this.val('已关注')
                .addClass("follow-btn-on _notFollowBtn")
                .removeClass("_followBtn");
            __org.recalcCurrFans('+');
            if (location.pathname == '/Org/orgSample') {
                window.location.reload();
            }

        });
    },
    recalcCurrFans(type) {
        var $currFans = $("#_currFans");
        var currFans = $currFans.text();

        $currFans.text(type == "+"?++currFans:--currFans);
    },
    // 取消关注按钮
    removeFollowingHandle(e) {
        e.preventDefault();
        let $this = $(this);
        let id = $this.data("id");

        __org.submitDataHandle('/org/ajaxDelFollow', 'post', { crowd_id: id }, (data) => {
            layer.msg("取消关注成功");
            $this.val('关注')
                .removeClass("follow-btn-on _notFollowBtn")
                .addClass("_followBtn follow-btn");
            __org.recalcCurrFans('-');
        });
    },
    submitDataHandle(url, type, data, callBack) {
        $ajax({
            type: type,
            url: url,
            data: data,
            dataType: 'json',
            callback: (json) => {
                callBack && callBack(json);
            }
        });
    },
    // 加载更多的标签显示的文字
    setLoadLabelText() {
        let text = '';

        // 如果还有下一页
        if (__data.hasNextPage) {
            // 如果在加载中
            if (__data.isLoadMore) {
                text = '加载中...';
                // 如果加载完成
            } else {
                text = '加载更多';
            }
            // 没有数据
        } else {
            text = '暂无更多~';
        }
        __data.loadMoreLabel.text(text);
    },
    // 处理动态内容文本。判断是否当前的文本的长度满足了显示
    // 查看全文按钮的条件，如果满足了。就显示查看全文按钮
    setLoadMoreBtnStatus() {
        let content = $("._msgWords");
        let maxLimitNum = 92;
        let msg = '';
        let html = '';
        let urlList = [];

        content.each((index, item) => {
            var list = $(item).find('.highlight');

            urlList = [];
            msg = $(item).text();
            html = $(item).html();
            list.each((index, item) => {
                urlList.push($(item).attr('href'));
            });
            $(item).attr("data-text", html);
            if (msg.length > maxLimitNum) {
                $(item)
                    .html(__org.restoreHtmlStr(msg.slice(0, maxLimitNum), urlList) + "...")
                    .parent().find("._lookFullDymContent").slideDown();
            }
        });
    },
    // 恢复截取的长度的文本中的话题
    restoreHtmlStr(str, urlList = []) {
        let _str = '';
        let arr = str.split(/(#.+?#)/);
        let index = 0;
        let strArr = arr.map((item) => {
            if (item.match(/(#.+?#)/)) {
                item = `<a class="highlight" href="${urlList[index]}">${item}</a>`;
                index++;
            }
            return item;
        });

        return strArr.join('');
    },
    // 点击查看全文按钮。显示全文
    showFullContentTitle() {
        let $this = $(this);
        let msgContext = $this.parent().find("._msgWords");
        let fullMsg = msgContext.attr("data-text");
        let currMsg = msgContext.text();
        let defaultText = $(this).text();

        if ($this.hasClass("_slideUp")) {
            $this.text(defaultText);
        } else {
            $this.text("收起");
        }
        msgContext.text(fullMsg).attr("data-text", currMsg);

        $this.toggleClass("_slideUp");
    },
    // 滚动加载数据
    scrollLoadData(e) {
        let { scrollTop: st, scrollHeight: sc, clientHeight: ch } = document.documentElement;

        // 如果页面高度加上滚动过去的高度大于了总的页面内容高度
        // 就判断是否加载更多
        if (__data.hasNextPage) {
            if (st + ch >= sc) {
                if (!__data.isLoadMore) {
                    __data.isLoadMore = true;
                    __org.setLoadLabelText();
                    __data.hasNextPage = false;

                    switch (+pageType) {
                        case 4:
                            __org.getDynamicsList();
                            break;
                        case 3:
                            __org.getArticleList();
                            break;
                        case 2:
                            __org.getFansList();
                            break;
                        case 1:
                            __org.getOrgMemberList();
                    }
                }
            }
        }
    },
    getDynamicsList() {
        $ajax({
            url: '/org/ajaxGetDynamicList',
            type: 'get',
            data: {
                id: __data.groupId,
                page: __data.page
            },
            callback: ({ data }) => {

                if (data.length == 0) {
                    __data.hasNextPage = false;
                } else {
                    if (data.length < __data.PAGE_LIMIT) {
                        __data.hasNextPage = false;
                    } else {
                        setTimeout(() => {
                            __data.hasNextPage = true;
                        }, 200);
                    }
                    // 对列表的点赞转发评论加上是否上万的处理
                    let _list = data && __org.dealNumberByTenThousand(data);

                    _list.map(item => {
                        item.showContent = item.content;
                        item.dealContent = __org.dealContentText(item.content1);
                        item.ctime = window.util.getPubtime(new Date().getTime() / 1000 - item.create_time);
                        if (item.sourceWeibo && item.sourceWeibo.id) {
                            item.sourceWeibo.dealContent = __org.dealContentText(item.sourceWeibo.content1);
                        }
                        return item;
                    });
                    __org.setLoadMoreBtnStatus();
                    __data.page++;
                    __data.isLoadMore = false;
                    $('._userDynamicContent').append(dynamic({ list: _list, type: 1, uid: __data.uid, noAvatorLink: true, noLastTwoBtn: true }));
                }

                __org.setLoadLabelText();
            }
        });
    },
    // ##2#6159#天气话题## 天哪天企鹅晚饭",//##1 是@用户 ##2是话题  第二位数字是代表用户ID或者话题ID
    dealContentText(str) {
        const USER = /##1#(\d+)(#.+?#)#/g;
        const TOPIC = /##2#(\d+)(#.+?#)#/g;

        let endStr = str.replace(USER, (match, p1, p2) => {
            return '<a class="highlight" href="/user/heindex?uid=' + p1 + '">@' + p2 + '</a>';
        }).replace(TOPIC, (match, p1, p2) => {
            return '<a class="highlight" href="/sns/topicDetail?id=' + p1 + '">' + p2 + '</a>';
        });

        return endStr;
    },
    // 处理数字的操作
    // 根据数量是否大于万来确定。如果大于万。显示多少万
    dealNumberByTenThousand(data, keys = ["comment_count", "support_count"]) {
        let keysSet = new Set(keys);

        return data.map(item => {
            for (let key in item) {
                if (keysSet.has(key)) {
                    item[key + '_deal'] = window.util.getNumberByTenThousand(item[key]);
                }
            }
            return item;
        });
    },
    getFansList() {
        __org.submitDataHandle('/org/ajaxGetFansList', 'get', { id: __data.groupId, page: __data.page }, (data) => {
            const _data = data.data;

            __org.setHasNextPageStatus(_data);
            $('._friendBox').append(organizationMember(data));
        });
    },
    getArticleList() {
        __org.submitDataHandle('/org/ajaxGetArticleList', 'get', { id: __data.groupId, page: __data.page, menu_id: window.util.queryString().menu_id }, (data) => {
            const _data = data.data;

            __org.setHasNextPageStatus(_data);
            $('._articleBox').append(article(data));
        });
    },
    getOrgMemberList() {
        __org.submitDataHandle('/org/ajaxGetMemberList', 'get', { id: __data.groupId, page: __data.page }, (data) => {
            const _data = data.data;

            __org.setHasNextPageStatus(_data);
            $('._memberBox').append(fans(data));
        });
    },
    setHasNextPageStatus(_data) {
        if (_data.length < __data.PAGE_LIMIT) {
            __data.hasNextPage = false;
            __org.setLoadLabelText();
        } else {
            setTimeout(() => {
                __data.hasNextPage = true;
                __org.setLoadLabelText();
            }, 200);
            __data.page++;
            __data.isLoadMore = false;
        }
    },
    // 初始化百度地图
    initBaiduMap: function () {
        // 初始化经纬度lng经度  lat纬度
        let [city, place] = [$("._map").data('cityCode'), $("._map").text()];
        // 百度地图API功能
        var map = new BMap.Map("map_baidu");
        var point = new BMap.Point(116.331398, 39.897445);
        // 创建地址解析器实例
        var myGeo = new BMap.Geocoder();

        map.centerAndZoom(point, 12);
        // 地图定位
        // 将地址解析结果显示在地图上,并调整地图视野

        myGeo.getPoint(place, function (point) {
            if (point) {
                map.centerAndZoom(point, 18);
                map.addOverlay(new BMap.Marker(point));
            } else {
                // layer.msg("您选择地址没有解析到结果!");
                return false;
            }
        }, city);
    },
    // 生成海报
    creatPoster: function () {
        const dom = $('#poster');

        html2canvas(document.getElementById("poster"), {
            width: 350,
            height: 620,
            y: dom.offset().top,
            x: dom.offset().left,
            useCORS: true, // 【重要】开启跨域配置
            // scale: window.devicePixelRatio < 3 ? window.devicePixelRatio : 2,
            allowTaint: true // 允许跨域图片
        }).then(function (canvas) {
            var imgUri = canvas.toDataURL("image/png"); // 获取生成的图片的url

            __data.postUrl = imgUri;

        });
    },
    // 下载图片
    handleDownPoster() {
        fetch(__data.postUrl)
            .then(res => res.blob().then(blob => {
                const a = document.createElement('a'),  // 动态创建a标签，防止下载大文件时，用户没看到下载提示连续点击
                    url = window.URL.createObjectURL(blob),
                    filename = '海报';

                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }));
    },
    init() {
        // 获取当页数据的weiboId
        let dynList = $('._dynamicMainContent');
        let len = dynList.length;
        const navList = $('._navList li');

        __data.groupId = window.util.queryString().id;
        // 滚动到底部加载更多数据
        $(window).on("scroll", __org.scrollLoadData);
        navList.eq(+pageType).addClass('active');
        switch (+pageType) {
            case 4:
                // const dynmicList = $('._userDynamicContent').find('._dynamicMainContent');
                const dynmicList = $('._userDynamicContent').find('._userContent');


                if (dynmicList.length < __data.PAGE_LIMIT) {
                    __data.hasNextPage = false;
                }
                break;
            case 3:
                const articleBox = $('._articleBox');

                if (articleBox.find('._articleItem').length < __data.PAGE_LIMIT) {
                    __data.hasNextPage = false;
                }
                break;
            case 2:
                const friendBox = $('._friendBox');

                if (friendBox.find('li').length < __data.PAGE_LIMIT) {
                    __data.hasNextPage = false;
                }
                break;
            case 1:
                const memberBox = $('._memberBox');

                if (memberBox.find('li').length < __data.PAGE_LIMIT) {
                    __data.hasNextPage = false;
                }
        }
        __data.loadMoreLabel = $('._loadMoreTip');
        __org.setLoadLabelText();
        __org.setLoadMoreBtnStatus();
        if ($("#map_baidu").length) {
            __org.initBaiduMap();
        }
        // 生成海报
        if ($("#poster").length) {
            setTimeout(() => {
                __org.creatPoster();
            }, 0);
        }

    }
};

$(function () {
    __org.init();

    $(document)
        .on("click", '._slide', __org.slide)
        .on("click", '.learning-show-btn', __org.showDownList)
        .on("click", '._lookFullDymContent', __org.showFullContentTitle)
        .on("click", "._followBtn", __org.followingHandle)
        .on("click", "._orgBranch", __org.getOrgBranch)
        .on("click", "._notFollowBtn", __org.removeFollowingHandle)
        .on("click", "._downloadBtn", __org.handleDownPoster);

});